import { render, staticRenderFns } from "./setting-defaultEmailTemplates.vue?vue&type=template&id=ae03fece&scoped=true&"
import script from "./setting-defaultEmailTemplates.vue?vue&type=script&lang=js&"
export * from "./setting-defaultEmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./setting-defaultEmailTemplates.vue?vue&type=style&index=0&id=ae03fece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae03fece",
  null
  
)

export default component.exports